"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12.507 16.996a4 4 0 0 1-.174.004H7.167a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h5.666a3 3 0 0 1 3 3v7.578a3.5 3.5 0 0 1-3.326 3.418m1.926-4.818V5.999a1.6 1.6 0 0 0-1.6-1.599H7.167a1.6 1.6 0 0 0-1.6 1.6v8a1.6 1.6 0 0 0 1.6 1.6h3.94v-.722a2.7 2.7 0 0 1 2.7-2.7zm-1.926 3.415v-.715a1.3 1.3 0 0 1 1.3-1.3h.625a2.1 2.1 0 0 1-1.925 2.015",
  clipRule: "evenodd"
}), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M11.688 11.056v-2.45h1.942v.682h-1.155v.368h.875v.63h-.875v.77zm-2.694 0v-2.45h.98c.77 0 1.33.56 1.33 1.225s-.56 1.225-1.33 1.225zm.788-.665h.175c.332 0 .56-.228.56-.56a.533.533 0 0 0-.56-.56h-.175zm-3.255.665v-2.45H7.68c.56 0 .946.385.946.892 0 .508-.386.893-.946.893h-.367v.665zm.787-1.33h.28c.14 0 .245-.105.245-.228 0-.122-.105-.227-.245-.227h-.28z"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=PdfFileIcon20.js.map